<template lang="pug">
  .order-step
    h1.h2.u-mb-sm(v-if="isFirst") {{ $t('title') }}
    slot
    .order-next(v-if="controls")
      button.button-link.is-medium(@click.prevent="$emit('next')" ) {{ $t('next') }}
      p(v-html="$t(tip)" class="order-tip")
</template>

<script>
export default {
  name: 'OrderStep',
  props: {
    controls: {
      type: Boolean,
      default: true
    },
    tip: {
      type: String,
      default: 'pressEnter'
    },
    isFirst: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<i18n>
{
  "en": {
    "title": "Ordering",
    "next": "Next",
    "pressEnter": "Press <b>ENTER</b>",
    "linebreak": "<b>SHIFT + ENTER</b> to make a line break"
  },
  "ar": {
    "title": "طلب الخدمة",
    "next": "التالي",
    "pressEnter": "اضغط <b>ENTER</b>",
    "linebreak": "<b>SHIFT + ENTER</b> لاضافة سطر"
  }
}
</i18n>
